export const checklistsText = {
  header: "Your Checklists",
  description:
    "Help your users get started with the most important tasks, encourage them along the way, and reward them at the end."
};
